<template>
  <div class="row">
    <div class="col-12">
      <div class="tile">
        <div class="alert alert-info"><b>Xoá cache hệ thống</b></div>
        <div class="row">
          <div class="col-8">
            <form-input :model="formModel" attribute="pattern" :errors="formErrors" placeholder="Key cần xoá"></form-input>
          </div>
          <div class="col-4">
            <button @click="clear" class="btn btn-primary">Xoá</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  mixins: [],
  data: function () {
    return {
      formErrors: [],
      service: "/clear-cache",
      autoLoad: false,
      formModel: {
        pattern: null,
      },
    };
  },
  methods: {
    clear: function () {
      this.$swal({
        title: 'Bạn có chắc muốn thục hiện hành động này',
        icon: "question",
        showCancelButton: true
      }).then((result) => {
        if (result.value) {
          let loader = this.$loading.show()
          this.$service({url: this.service, method: 'post', data: this.formModel}).then(response => {
            if (response.data) {
              this.$swal({
                title: this.$t('success'),
                text: `Đã xoá ${response.data} key`,
                icon: 'success'
              });
              this.formModel.pattern = null;
            } else {
              this.$swal({
                text: `Không tìm thấy key`,
                icon: 'warning'
              });
            }
          }).catch(error => {
            if (error.response.data.message) {
              this.$swal({
                text: error.response.data.message,
                icon: 'error'
              });
            } else {
              this.formErrors = error.response.data;
            }
          }).finally(() => {
            loader.hide();
          });
        }
      });
    },
  },
};
</script>
